import React from "react";

export default function History_Computing() {
  return (
    <div>
      <h1>History_Computing</h1>
      <p>This is the History_Computing component.</p>
    </div>
  );
}
